import { createAction } from '@reduxjs/toolkit'

export const formDestroy = createAction('formDestroy')
